import React from 'react';
import classNames from 'classnames';

import InfoTag from '../InfoTag/InfoTag';
import ErrorMessage from '../../../../design-system/ErrorMessage/ErrorMessage';

const VariablesContentSection = ({ groupFormData, setGroupFormData = () => {}, isEditable }) => {
    if (!groupFormData || groupFormData.length === 0) return null;

    const isError = groupFormData.some(({ state }) => state === 'error');

    return (
        <div className="flex flex-col gap-1">
            <ul className="flex flex-wrap gap-2.5 lg:grid lg:grid-cols-2 l:flex -mt-2.5">
                {groupFormData.map((variable) => {
                    const { order, name, label, description, example, state } = variable;
                    const withExampleTag = variable.hasOwnProperty('example');

                    const setVariable = (cb) => {
                        setGroupFormData((variables) => {
                            return variables.map((variable) => {
                                if (variable.name === name) {
                                    const updatedVariable =
                                        typeof cb === 'function' ? cb(variable) : cb;
                                    const { value, ...rest } = updatedVariable;
                                    return { ...rest, example: value, state: 'default' };
                                }
                                return variable;
                            });
                        });
                    };

                    const containerClassName = classNames(
                        'w-full md:w-[318px] lg:w-full l:w-[318px] self-stretch p-4 flex flex-col gap-4 justify-between border rounded-2 bg-white transition',
                        {
                            'border-neutral-200': state !== 'error',
                            'border-red-500': state === 'error',
                        }
                    );

                    return (
                        <li key={name + order} className={containerClassName}>
                            <div className="flex flex-col gap-2">
                                <p className="font-body-bold text-body-bold-s text-neutral-500">
                                    {label}
                                </p>
                                <p className="font-body text-body-regular-xs text-neutral-500">
                                    {description}
                                </p>
                            </div>

                            {withExampleTag && (
                                <InfoTag
                                    type="example"
                                    data={{ ...variable, is_required: true, value: example }}
                                    setData={setVariable}
                                    isEditable={isEditable}
                                />
                            )}
                        </li>
                    );
                })}
            </ul>

            {isError && <ErrorMessage message="Please fill in all example tags." />}
        </div>
    );
};

export default VariablesContentSection;
